import { render, staticRenderFns } from "./stcolumnarChart.vue?vue&type=template&id=748caba5&scoped=true"
import script from "./stcolumnarChart.vue?vue&type=script&lang=js"
export * from "./stcolumnarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748caba5",
  null
  
)

export default component.exports